import React from 'react';
import { ReactTitle } from 'react-meta-tags';
import PropTypes from 'prop-types';

const PageTitle = ({ title }) => {
  return (
    <ReactTitle title={`${title} | BridgeBee`} />
  );
}

PageTitle.propTypes = {
  title: PropTypes.string.isRequired
};

export default PageTitle;
